module.exports = {
  default: "jhensley@givepower.org",
  partners: [
    {
      id: "Loanpal",
      partnerId: "Loanpal",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1/loanpal.com/lpsmile_white_orange_o-R.11c11dde.svg",
      size: "250px",
      sizeM: "155px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: true,
      goal: 10000,
      name: "Loanpal",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      donateButtonOn: false,
      gpLogoSize: "60px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_d1d60b795594",
      title: "BE THE POWER FOR CHANGE",
    },
    {
      id: "LoanpalMobi",
      partnerId: "LoanpalMobi",
      icon:
        "https://cdn.bfldr.com/Q445447Z/at/8z6tv7w3583ktx2hfjwgk5h9/goodleap-white-grad-15x.png?auto=webp&format=png",
        //"https://frame.bfldr.com/Q445447Z/at/8z6tv7w3583ktx2hfjwgk5h9/goodleap-white-grad-15x.png",
      size: "180px",
      sizeM: "130px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: true,
      goal: 120000,
      name: "GoodLeap",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "60px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_15412b27e2f4",
      donateButtonOn: false,
      title: "THE CHALLENGE",
      description:
        "Team GoodLeap is in the home stretch to raise the final $30,000 to fully fund the GivePower Solar Water Farm™ Mobi for Lamu Island, Kenya. The total funding goal is $120,000 and we will get there with your continued generosity.",
      description2:
        "The Mobi you helping to fund is more compact than its larger counterpart, the Max, and designed for more rapid deployment. This new system allows GivePower to generate clean water within a week of the equipment arriving in a new location. Each Mobi can provide up to 6,000 liters of fresh water daily. That’s clean drinking water for up to 3,000 people every single day for the next 20 years!",
      description3: 
        "To learn about the dire water crisis on Lamu Island and how your donation will make a critical impact in this community, watch this quick video.",
    },
    /*{
      id: "Haiti",
      partnerId: "Haiti",
      icon:
        "https://cdn.bfldr.com/Q445447Z/at/8z6tv7w3583ktx2hfjwgk5h9/goodleap-white-grad-15x.png?auto=webp&format=png",
        //"https://frame.bfldr.com/Q445447Z/at/8z6tv7w3583ktx2hfjwgk5h9/goodleap-white-grad-15x.png",
      size: "0px",
      sizeM: "0px",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 120000,
      name: "Haiti",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "70px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_109ff0644a5f",
      donateButtonOn: false,
      title: "At a time when clean water truly saves lives, GivePower is operating one of the few safe and reliable water sources in Haiti.",
      description:
        "The tragic situation in Haiti has presented GivePower with a meaningful and unexpected opportunity to make an impact. We built our Solar Water Farms to provide critical, life-saving resources to communities in need on a daily basis. This week, we also found ourselves responding to a crisis. As the massive 7.2 magnitude earthquake hit Haiti on Saturday, August 14th, our team acted quickly to bring emergency water supplies to survivors in hard-hit areas of the country.",
      description2:
        "GivePower completed a Solar Water Farm Max on the Haitian island of La Gonâve in May of 2020. Haiti is the poorest country in the Western Hemisphere and La Gonâve is known as its “forgotten island.” As the pandemic introduced new challenges, GivePower considered pausing deployment of the desalination plant, but our Site Manager, Getro Deliscas, had other ideas. Through great effort, he inspired us to move forward with the project, and we couldn’t be more grateful that he did.",
      description3: 
        "The Saturday earthquake has so far claimed the lives of more than 2,100 people.  UNICEF estimates that 1.2 million others, including 540,000 children have been affected.  One of the hardest hit cities was Les Cayes, coincidentally, Getro’s hometown – and the home he saved up to build for his family was tragically destroyed.",
      description4:
        "Meanwhile, GivePower’s Solar Water Farm remains intact and fully operational. It is now one of the few reliable sources of clean water in the country. Getro and his team – despite the loss they suffered – are on the ground, working tirelessly to bring clean water to others. And they need your help!",
      description5:
        "Our ambitious goal is to transfer 30,000 liters every day for as long as we’re needed to support the daily drinking requirements of up to 15,000 people in areas devastated by the earthquake, while continuing to serve the community of La Gonâve. Solving big problems with solar-powered solutions motivates our work, but rarely are we put to this kind of rigorous test. Our work simply would not be possible without your support.",
      description6:
        "Please donate now to help ramp and sustain our efforts in Haiti.",
      description7:
        "Your donation will enable GivePower to continue to bring live-saving drinking water to the people in Haiti whose lives have been devastated by this quake.",
      description8:
        "On behalf of the team at GivePower and all of those we serve, thank you for your support."
    },*/
    {
      id: "AcrossTheGlobe",
      partnerId: "AcrossTheGlobe",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1646264783/partners/AcrossTheGlobe.png",
      size: "140px",
      sizeM: "80px",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 5000,
      name: "Across the Globe",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "70px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_74e60fc41cbd",
      donateButtonOn: false,
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Across the Globe has the opportunity to make a difference in hundreds, if not thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3: 
        "Across the Globe is proud to support the GivePower Foundation. We are committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
      description4:
        "On behalf of Across the Globe and GivePower, we thank you for your support.",
    },
    {
      id: "FLSEIA",
      partnerId: "Flaseia",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1/partners/originals/Flaseia-logo.png",
      size: "250px",
      sizeM: "150px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 10000,
      name: "FlaSEIA",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      donateButtonOn: false,
      gpLogoSize: "55px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_d5c19a40f18b",
    },
    {
      id: "Trismart",
      partnerId: "Trismart",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1/partners/originals/trismart-white.png",
      size: "250px",
      sizeM: "150px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 10000,
      name: "Trismart Solar",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "55px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_21544a5c63e5",
      title: "BE THE POWER FOR CHANGE",
      donateButtonOn: false,
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, TriSMART Solar has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "TriSMART is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "OurWorldEnergy",
      partnerId: "OurWorldEnergy",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1589302630/partners/originals/ourworldenergy.png",
      size: "180px",
      sizeM: "108px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 100000,
      // email: 'cantonucci@ourworldenergy.com',
      name: "Our World Energy",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "55px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_7bd5f131b040",
      title: "BE THE POWER FOR CHANGE",
      donateButtonOn: false,
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Our World Energy has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Our World Energy is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "DaybreakSolar",
      partnerId: "DaybreakSolar",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1589302630/partners/originals/daybreak-solar.png",
      size: "180px",
      sizeM: "108px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 10000,
      name: "Daybreak Solar",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "55px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_c9d22e2f35bb",
      title: "BE THE POWER FOR CHANGE",
      donateButtonOn: false,
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Daybreak Solar Power has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Daybreak Solar Power is proud to make a $100 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "SkylineSolarPower",
      partnerId: "SkylineSolarPower",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1589302630/partners/originals/skylineSolar_1.png",
      size: "320px",
      sizeM: "192px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 100000,
      name: "Skyline Solar Power",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_1f9fe3fbd407",
      title: "BE THE POWER FOR CHANGE",
      donateButtonOn: false,
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Skyline Solar Power has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Skyline Solar Power is proud to make a $20 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "PineGateRenewables",
      partnerId: "PineGateRenewables",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/v1603472774/partners/originals/PineGateRenewables_logo_white-o.png",
      size: "280px",
      sizeM: "165px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 100000,
      name: "Pine Gate Renewables",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_a2f5da9aff3f",
      title: "BE THE POWER FOR CHANGE",
      donateButtonOn: false,
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Pine Gate Renewables has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Pine Gate Renewables is proud to make a donation of $200/megawatt DC solar install to GivePower. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "ExpertSolarPros",
      partnerId: "ExpertSolarPros",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/w_auto,q_auto,dpr_auto,c_scale/v1/partners/originals/ExpertSolarPros.png",
      size: "250px",
      sizeM: "150px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 100000,
      name: "Expert Solar Pros",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_0e5d79d4c0fc",
      title: "BE THE POWER FOR CHANGE",
      donateButtonOn: false,
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Expert Solar Pros has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Expert Solar Pros is proud to make a $20 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "1Solar",
      partnerId: "1Solar",
      //partnerId: "BellSolarAndElectricalSystems",
      icon:
        //"https://res.cloudinary.com/loanpal/image/upload/v1604422020/partners/originals/BellSolarElectrical.png",
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_210,g_face/v1710435704/givepower/donate/partners/1Solar_Logo_Black.png",
      size: "210px",
      sizeM: "150px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 100000,
      name: "1Solar",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_a75da43aef6e",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, 1Solar has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "1Solar is proud to make a $5 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "NextDoorHomeUpgrades",
      partnerId: "NextDoorHomeUpgrades",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/v1617292909/partners/originals/NextDoorLogo.png",
      size: "210px",
      sizeM: "120px",
      link: "",
      email: "hsanchez@loanpal.com",
      progress: false,
      goal: 100000,
      name: "Next Door Home Upgrades",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_981173706b26",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Next Door Home Upgrades has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Next Door Home Upgrades is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "GoBundance",
      partnerId: "GoBundance",
      icon:
        "https://cdn.brandfolder.io/Q445447Z/at/8swmf7r96qsn6zh44xx4tzwx/gobundance-logo.png?height=65&width=200",
      size: "200px",
      sizeM: "120px",
      link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "GoBundance",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_fccce5a405fb",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, GoBundance has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "",
    },
    {
      id: "Soligent",
      partnerId: "Soligent",
      icon:
        "https://cdn.brandfolder.io/Q445447Z/at/2vt59fs5mpb8gj3s64pm665/soligent-logo.png?height=96&width=200",
      size: "200px",
      sizeM: "120px",
      link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Soligent",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_39dd9981fd44",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Soligent has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective.",
      description3:
        "For every GoodLeap funding, 5 people will receive access to clean water through clean energy for 1 full year. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "PowurHitters",
      partnerId: "PowurHitters",
      icon:
        "https://cdn.brandfolder.io/Q445447Z/at/5j4srzb7tm2xbxcz34kx5vb/powur-logo.png?height=60&width=200",
      size: "200px",
      sizeM: "120px",
      link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Powur Hitters",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_1f17661ac946",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Powur Hitters has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Powur Hitters is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "SolarPlanet",
      partnerId: "SolarPlanet",
      icon:
        "https://givepower.org/wp-content/uploads/2021/08/solarplanet-e1628703699455.jpg",
      size: "100px",
      sizeM: "120px",
      link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Solar Planet",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_2fc448132523",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Solar Planet has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Solar Planet is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "HelixSun",
      partnerId: "HelixSun",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1632269653/partners/originals/HelixSunLogo.png",
      size: "250",
      sizeM: "120px",
      link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Heilx Sun",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_0567ee791aa8",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Helix Sun has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Helix Sun is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "CheetahSolar",
      partnerId: "CheetahSolar",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1636576318/partners/CheetahSolar_inv.png",
      size: "250",
      sizeM: "120px",
      link: "https://www.cheetahsolar.co",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Cheetah Solar",
      bg: "bg-inverse",
      gpLogo: "givepower_TM_logo_Horizontal_White.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_836ebd0153bb",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Cheetah Solar has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "Cheetah Solar is proud to make a $1 donation to GivePower for every solar panel installed through Cheetah Solar. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "EvergreenSolar",
      partnerId: "EvergreenSolar",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1646262255/partners/PNG_EVG_LOGO_WHITE_BCK_ONLY.png",
      size: "250",
      sizeM: "120px",
      link: "https://evergreen4life.com/",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Evergreen Solar",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_9e6a265f9ffa",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Evergreen Solar Solutions has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "We are proud to make a $20 donation to GivePower for every solar installation done through Evergreen Solar Solutions. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "Fivetran",
      partnerId: "Fivetran",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1646264016/partners/fivetran-logo-blue-rgb.png",
      size: "250",
      sizeM: "120px",
      link: "https://www.fivetran.com/",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Fivetran",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_0958dfe4bd2c",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Fivetran has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, a simple $20 investment can give one person access to safe drinking water for at least 20 years.",
      description3:
        "",
    },
    {
      id: "GoodDayFinancial",
      partnerId: "GoodDayFinancial",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_210,g_face/v1651256524/partners/GOOD_DAY_color_02.jpg",
      size: "210",
      sizeM: "120px",
      link: "https://www.gooddayloans.com/philanthropy",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 50000,
      name: "Good Day Financial",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_b7c3e29ad382",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Good Day Financial has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      description3:
        "Good Day Financial is proud to make a $100 donation to GivePower for every closed loan. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "SouthwestElectric",
      partnerId: "SouthwestElectric",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1652472408/partners/southwest-electric-wh.png",
      size: "210",
      sizeM: "120px",
      link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 50000,
      name: "Southwest Electric",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_cda97ebc29f8",
      //donationScriptSrc: "https://secure.givelively.org/widgets/branded_donation/givepower-foundation/southwest-electric.js",
      //donationWidgetSrc: "https://secure.givelively.org/donate/givepower-foundation/southwest-electric?ref=sd_widget",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Southwest Electric has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      description3:
        "Southwest Electric is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "VirginiaEnergySolutions",
      partnerId: "VirginiaEnergySolutions",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1666119964/givepower/donate/partners/virginiaenergysolutions_logo.png",
      size: "210",
      sizeM: "120px",
      link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 50000,
      name: "Virginia Energy Solutions",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_8d9e313d82fc",
      //donationScriptSrc: "https://secure.givelively.org/widgets/branded_donation/givepower-foundation/southwest-electric.js",
      //donationWidgetSrc: "https://secure.givelively.org/donate/givepower-foundation/southwest-electric?ref=sd_widget",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Virginia Energy Solutions has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      description3:
        "Virginia Energy Solutions is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "GoodFaithEnergy",
      partnerId: "GoodFaithEnergy",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_250,g_face/v1676495339/givepower/donate/partners/Good_Faith_Energy.png",
      size: "210",
      sizeM: "120px",
      link: "https://goodfaithenergy.com/",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 50000,
      name: "Good Faith Energy ",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_48951d67839e",
      //donationScriptSrc: "https://secure.givelively.org/widgets/branded_donation/givepower-foundation/southwest-electric.js",
      //donationWidgetSrc: "https://secure.givelively.org/donate/givepower-foundation/southwest-electric?ref=sd_widget",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Good Faith Energy has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      description3:
        "Good Faith Energy is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "InMemoryOfLuca",
      partnerId: "InMemoryOfLuca",
      //icon:
      //  "",
      //size: "210",
      //sizeM: "120px",
      //link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 50000,
      //name: "",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_dd7c40ed3987",
      //donationScriptSrc: "https://secure.givelively.org/widgets/branded_donation/givepower-foundation/southwest-electric.js",
      //donationWidgetSrc: "https://secure.givelively.org/donate/givepower-foundation/southwest-electric?ref=sd_widget",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "IN MEMORY OF LUCA - BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      //description2:
      //  "In partnership with GivePower, Good Faith Energy has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      //description3:
      //  "Good Faith Energy is proud to make a $40 donation to GivePower for every solar installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "ImperialHomeExperts",
      partnerId: "ImperialHomeExperts",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_210,g_face/v1698168561/partners/Imperial_logo.jpg",
      size: "210",
      sizeM: "120px",
      link: "https://Imperialhomeexperts.com",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Imperial Home Experts",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_625bade6db34",
      //donationScriptSrc: "https://secure.givelively.org/widgets/branded_donation/givepower-foundation/southwest-electric.js",
      //donationWidgetSrc: "https://secure.givelively.org/donate/givepower-foundation/southwest-electric?ref=sd_widget",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Imperial Home Experts has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      description3:
        "Imperial Home Experts is proud to make a $20 donation to GivePower for every water installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "Soligo",
      partnerId: "Soligo",
      icon:
        //"https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_210,g_face/v1698168561/partners/Imperial_logo.jpg
        //"https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_210,g_face/v1702427073/partners/lux.png"
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_200,g_face/v1710187414/givepower/donate/partners/Soligo_Black_logo-nb.png",
      size: "210",
      sizeM: "120px",
      link: "https://luxenergy.io",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Soligo",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_c604ef5be50a",
      //donationScriptSrc: "",
      //donationWidgetSrc: "",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Soligo has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      description3:
        "Soligo is proud to make a $40 donation to GivePower for every water installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "SunsolarSolutions",
      partnerId: "SunsolarSolutions",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_180,g_face/v1708473774/givepower/donate/partners/sunstorsolutions_logo.jpg",
      size: "180",
      sizeM: "120px",
      link: "https://sunsolarsolutions.com/",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Sunsolar Solutions",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_efcae8dc5cf6",
      //donationScriptSrc: "",
      //donationWidgetSrc: "",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      description2:
        "In partnership with GivePower, Sunsolar Solutions has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      description3:
        "Sunsolar Solutions is proud to make a $40 donation to GivePower for every installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "DeadAndCo",
      partnerId: "DeadAndCo",
      icon:
        "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_110,g_face/v1721335360/givepower/donate/REVERB_Logo.png",
      size: "110",
      sizeM: "120px",
      //link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      name: "Reverb",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_507da3fdb18c",
      //donationScriptSrc: "",
      //donationWidgetSrc: "",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      //description2:
      //  "In partnership with GivePower, Sunsolar Solutions has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      //description3:
      //  "Sunsolar Solutions is proud to make a $40 donation to GivePower for every installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "Sunrebel",
      partnerId: "Sunrebel",
      //icon:
      //  "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_110,g_face/v1721335360/givepower/donate/REVERB_Logo.png",
      //size: "110",
      //sizeM: "120px",
      //link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      //name: "Sunrebel",
      bg: "bg-white",
      gpLogo: "givepower-Lockup-H-blk.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_9a3394ec0c95",
      //donationScriptSrc: "",
      //donationWidgetSrc: "",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      //description2:
      //  "In partnership with GivePower, Sunsolar Solutions has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      //description3:
      //  "Sunsolar Solutions is proud to make a $40 donation to GivePower for every installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
    {
      id: "makinganimpact",
      partnerId: "makinganimpact",
      //icon:
      //  "https://res.cloudinary.com/loanpal/image/upload/c_thumb,w_110,g_face/v1721335360/givepower/donate/REVERB_Logo.png",
      //size: "110",
      //sizeM: "120px",
      //link: "",
      email: "jhensley@givepower.org",
      progress: false,
      goal: 100000,
      //name: "Kelly Resendez",
      bg: "bg-white",
      gpLogo: "givepower_TM_logo_Horizontal_Black.svg",
      gpLogoSize: "68px",
      gpLogoSizeM: "38px",
      campaignId: "cmp_2b3aaa1eda10",
      //donationScriptSrc: "",
      //donationWidgetSrc: "",
      donateButtonOn: false,
      donateButton:
        "../../../resources/css/img/match/button-active-bell-min.png",
      primaryColor: "#53c0ea",
      secondaryColor: "#27264d",
      title: "BE THE POWER FOR CHANGE",
      description:
        "GivePower provides solar-based solutions that power life's basic needs for people in developing regions of the world. Waterborne disease is the planet's leading killer. It's no surprise when you consider that three out of ten people, worldwide, lack access to a safe, reliable source of water in their home. But, there is a lot that we can do to help.",
      //description2:
      //  "In partnership with GivePower, Sunsolar Solutions has the opportunity to make a difference in tens of thousands of lives. GivePower has developed an innovative solar-powered desalination system that is sustainable and highly cost-effective. In fact, one penny can provide one day of access to clean water for one person in need. That means for just $20, you can help thousands get access to clean water.",
      //description3:
      //  "Sunsolar Solutions is proud to make a $40 donation to GivePower for every installation we complete. As a company, we have always been committed to making the planet a healthier, safer place for people. Let's continue to be the power for change! Join the charge!",
    },
  ],
};
